export enum EImportType {
  POSITIONS = 0,
  LEVELS = 1,
  STRUCTURES = 2,
  AKT_QUESTIONS = 3
}
